import React from 'react';
import { Hero } from '../components/Hero';
import { ThePractice } from '../components/ThePractice';
import { VeraReserve } from '../components/VeraReserve';
import { OtherTiers } from '../components/OtherTiers';
import { SelectedVoices } from '../components/SelectedVoices';
import { Ashley } from '../components/Ashley';
import { Application } from '../components/Application';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="w-full bg-cream min-h-screen selection:bg-brass selection:text-cream" data-id="element-106" data-mp="1zk1z5pf6j8dw">
      <Hero data-id="element-107" data-mp="24haeli8y0ybg" />
      <ThePractice data-id="element-108" data-mp="24ivc9gqk0xdj" />
      <VeraReserve data-id="element-109" data-mp="29gd9waz4fq68" />
      <OtherTiers data-id="element-110" data-mp="29fvgdm3ufq20" />
      <SelectedVoices data-id="element-111" data-mp="29fbww0yjotlv" />
      <Ashley data-id="element-112" data-mp="29i7xxy5ovyej" />
      <Application data-id="element-113" data-mp="2dhqiutxig9hd" />
      <Footer data-id="element-114" data-mp="2di8cdissg9ll" />
    </main>;
}